import { render, staticRenderFns } from "./PackagingTracking_HuonTas_summary_summary.vue?vue&type=template&id=9065d926"
import script from "./PackagingTracking_HuonTas_summary_summary.vue?vue&type=script&lang=js"
export * from "./PackagingTracking_HuonTas_summary_summary.vue?vue&type=script&lang=js"
import style0 from "./PackagingTracking_HuonTas_summary_summary.vue?vue&type=style&index=0&id=9065d926&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports